import React from 'react';

import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { Modal } from 'components/common/modal';

import { closeModal } from 'features/modalSlice';
import { setTermsAndConditionsData } from 'features/userSlice';

import './TermsAndConditionsModal.css';

const TermsAndConditionsModal = ({ title }) => {
    const dispatch = useDispatch();

    const { isTermsAndConditionsModalOpen } = useSelector(
        (state) => state.modal
    );

    const termsAndConditionsData = useSelector(
        (state) => state.user?.setTermsAndConditionsData
    );

    const Lang = useSelector((state) => state.miniBookingWidget?.data?.Lang);
    const modalTitle =
        termsAndConditionsData?.modalTitle ||
        Lang?.termsAndConditions ||
        'Terms and Conditions';
    const handleModalClose = () => {
        dispatch(closeModal({ modalId: 'TermsAndConditionsModal' }));
        dispatch(setTermsAndConditionsData(null));
    };

    const renderContent = () => {
        return (
            <div className="ab-terms-and-conditions-cnt">
                <div className="ab-modaltext">
                    <div
                        dangerouslySetInnerHTML={{
                            __html: termsAndConditionsData?.modalContent,
                        }}
                    ></div>

                    <h4>{termsAndConditionsData?.cancellationPolicyType}</h4>
                    <div
                        dangerouslySetInnerHTML={{
                            __html: termsAndConditionsData?.cancellationPolicy,
                        }}
                    ></div>
                    <div
                        dangerouslySetInnerHTML={{
                            __html: termsAndConditionsData?.cancellationPenalty,
                        }}
                    ></div>
                </div>
                {termsAndConditionsData?.paymentPolicy && (
                    <div>
                        <h4>{Lang?.paymentPolicy}</h4>
                        <div
                            dangerouslySetInnerHTML={{
                                __html: termsAndConditionsData?.paymentPolicy,
                            }}
                        ></div>
                    </div>
                )}
            </div>
        );
    };

    return (
        <Modal
            className="ab-modal--terms-and-conditions"
            isOpen={isTermsAndConditionsModalOpen}
            onClose={handleModalClose}
            onOverlayClick={handleModalClose}
            placement="center"
            renderContent={renderContent}
            title={modalTitle}
            width={700}
        />
    );
};
TermsAndConditionsModal.propTypes = {
    title: PropTypes.string,
};

export default TermsAndConditionsModal;
